const StackedDialogConstants = {
  REGISTER: 'SR_STADIA_REGISTER',
  UNREGISTER: 'SR_STADIA_UNREGISTER'
};

export default StackedDialogConstants;